import { Modal } from "@vimeo/iris/components";

import { ModalStyled } from "./modal.styles";

interface Props {
    active: boolean;
    message: string;
    onClose: () => void;
    onCancelClicked: () => void;
    onConfirmClicked: () => void;
}

export function ConfirmModal(props: Props) {
    const { active, message, onClose, onCancelClicked, onConfirmClicked } =
        props;

    return (
        <Modal
            active={active}
            onClose={onClose}
            size="md"
            content={
                <ModalStyled>
                    <Modal.Header>Confirm Deletion</Modal.Header>
                    <p
                        className="slds-var-p-bottom_medium"
                        style={{ fontSize: "16px" }}
                    >
                        {message}
                    </p>
                    <Modal.Footer>
                        <Modal.SecondaryAction
                            key="cancelBtn"
                            onClick={onCancelClicked}
                        >
                            Cancel
                        </Modal.SecondaryAction>
                        <Modal.PrimaryAction
                            key="yesBtn"
                            onClick={onConfirmClicked}
                        >
                            Delete
                        </Modal.PrimaryAction>
                    </Modal.Footer>
                </ModalStyled>
            }
        ></Modal>
    );
}
